import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { format, parseISO, subYears } from "date-fns";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
// import "./HistoricalReturn.css"
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import animation from "../../../images/jm-animation.gif";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
// import SIPPerformancePdf from "../../../PDF/SIP_Performance_Leaflet_September_2025.pdf"
function HistoricalReturn(props) {
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [dataHis, setDataHis] = useState([]);
  const [value, setValue] = useState("1year");
  const { BaseURL } = useContext(URLstateContext);
  const [chartData, setchartData] = useState([]);
  const [loadingshow, setloadingshow] = useState(false);
  let getSchemeType = props.SchemeDesc.split("-")[0];
  let getSchemeCode = props.SchemeCode;
  



  const handleShow = () => {
    setShow(true);
  };
  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetRollingReturns", {
      IVSchemeCode: getSchemeCode,
      IVPlanType: getSchemeType,
      IVPeriod: value,
    }).then((data) => {
      
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setchartData(DecryptAESdata(data.data));
        setloadingshow(false);
      } else {
        setData(null);
        setloadingshow(false);
      }
    });
    GetPostMethodData(BaseURL + "GetHistoricalReturn", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
        
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        
        setDataHis(DecryptAESdata(data.data));
        
        setloadingshow(false);
      }
    });
    
  }, [BaseURL, value]);

 

  
  useLayoutEffect(() => {
    am5.addLicense("AM5C420959785");
    var root = am5.Root.new("chartdivHis");

    root.setThemes([am5themes_Animated.new(root)]);

    var chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        layout: root.verticalLayout,
      })
    );

    var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);

    var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
    xRenderer.labels.template.setAll({
      // rotation: -40,
      centerY: am5.p100,
      centerX: am5.p50,
      fontSize: 10,
    });

    var xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "country",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    var yRenderer = am5xy.AxisRendererY.new(root, {});
    yRenderer.labels.template.setAll({
      fontSize: 11,
    });
    yRenderer.labels.template.set("visible", true);

    var yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: yRenderer,
      })
    );

    yAxis.get("renderer").grid.template.setAll({
      strokeWidth: 0,
      visible: true,
    });

    xAxis.get("renderer").grid.template.setAll({
      location: 0,
      strokeWidth: 0,
      visible: true,
    });

    var series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Series 1",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value",
        stroke: am5.color(0x2a4e96),
        categoryXField: "country",
        tooltip: am5.Tooltip.new(root, {
          // labelText: "{valueY}"
          labelText: "{valueY}% of instance in the range {country}",
        }),
      })
    );

    series.set("fill", am5.color(0x2a4e96));

    function generateChartData() {
      let chartData = [];
      if (data != null && data != []) {
        for (var i = 0; i < data.length; i++) {
          chartData.push({
            country: "< 0%",
            value: data[i].I0,
          });
          chartData.push({
            country: "0 - 8%",
            value: data[i].I0to8,
          });
          chartData.push({
            country: "8 - 12%",
            value: data[i].I08to12,
          });
          chartData.push({
            country: "12 - 20%",
            value: data[i].I12to20,
          });
          chartData.push({
            country: "> 20%",
            value: data[i].I20,
          });
        }
      }
      return chartData;
    }

    let datanew = generateChartData();

    series.columns.template.setAll({
      width: 30,
    });

    xAxis.data.setAll(datanew);
    series.data.setAll(datanew);

    series.appear(1000);
    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data]);

  const formatDate = (date) => {
    return date ? format(parseISO(date), "do MMM, yyyy") : "-";
  };



  const RETURN_COLUMNS = [
  { label: "7 Days", sar: "SAR7D", voi: "VOI7D", type: "SAR" },
  { label: "15 Days", sar: "SAR15D", voi: "VOI15D", type: "SAR" },
  { label: "1 Month", sar: "SAR30D", voi: "VOI30D", type: "SAR" },
  { label: "3 Months", sar: "SAR3Mon", voi: "VOI3Mon", type: "SAR" },
  { label: "6 Months", sar: "SAR6Mon", voi: "VOI6Mon", type: "SAR" },
  { label: "1 Year", sar: "CAGR1Yr", voi: "VOI1Yr", type: "CAGR" },
  { label: "3 Year", sar: "CAGR3Yr", voi: "VOI3Yr", type: "CAGR" },
  { label: "5 Year", sar: "CAGR5Yr", voi: "VOI5Yr", type: "CAGR" },
  { label: "10 Year", sar: "CAGR10Yr", voi: "VOI10Yr", type: "CAGR" },
  { label: "Since Inception", sar: "CAGRInception", voi: "VOIInception", type: "CAGR" }
];

const availableColumns = RETURN_COLUMNS.filter(col =>
  dataHis?.some(item => item[col.sar] !== null && item[col.sar] !== undefined)
);


const asOnDate = dataHis && dataHis[0]?.AsonDate;
let dateRangeText = "";

if (asOnDate) {
  const parsedDate = parseISO(asOnDate);

  const endDate = format(parsedDate, "MMMM yyyy"); // March 2026
  const startDate = format(subYears(parsedDate, 3), "MMMM yyyy"); // March 2023

  dateRangeText = `${startDate} to ${endDate}`;
}

  return (
    <>
      <section className="product_performance-sc histReturn" id="performance">
        <div class="gradiant-head-container">
          <h3 class="gradiant-head left">Performance</h3>
        </div>
        {
          <Tabs defaultActiveKey="historicalReturns" transition={true}>
            <Tab eventKey="historicalReturns" title="Historical Returns">
              <div className="proformance-head paraHistorical">
                {dataHis && (
                  <p className="text-xsm">
                    As on -{" "}
                    {dataHis && dataHis[0] && dataHis[0].AsonDate
                      ? format(parseISO(dataHis[0].AsonDate), "do MMM, yyyy")
                      : "-"}
                  </p>
                )}
              </div>
              <div className="table-responsive" tabIndex={0} role="region" aria-label="Scheme Performance History Table">
                  {loadingshow ? (
                    <div className="textcentervertex HomeLoader">
                      <img src={animation} alt="Loading" />
                      <div className="model_popup">Please Wait...</div>
                    </div>
                  ) : (
                    <div>
                      {dataHis && dataHis.length === 0 ? (
                        <h5 className="errormsgComNew">No Data Available</h5>
                      ) : (
                        <>
                          {dataHis && dataHis.length > 0 ? (
                            <table className="table">
                              {/* <thead>
                                <tr>
                                  <th colSpan="2"></th>
                                  {dataHis[0] && dataHis[0].SAR7D != null && (
                                    <th colSpan="2">7 Days</th>
                                  )}
                                  {dataHis[0] && dataHis[0].SAR15D != null && (
                                    <th colSpan="2">15 Days</th>
                                  )}
                                  {dataHis[0] && dataHis[0].SAR30D != null && (
                                    <th colSpan="2">30 Days</th>
                                  )}
                                   {dataHis[0] && dataHis[0].SAR3Mon != null && (
                                    <th colSpan="2">3 Months</th>
                                  )}
                                  {dataHis[0] && dataHis[0].SAR6Mon != null && (
                                    <th colSpan="2">6 Months</th>
                                  )}
                                  {dataHis[0] && dataHis[0].CAGR1Yr != null && (
                                    <th colSpan="2">1 Year</th>
                                  )}
                                  {dataHis[0] && dataHis[0].CAGR3Yr != null && (
                                    <th colSpan="2">3 Year</th>
                                  )}
                                  {dataHis[0] && dataHis[0].CAGR5Yr != null && (
                                    <th colSpan="2">5 Year</th>
                                  )}
                                   {dataHis[0] && dataHis[0].CAGR10Yr != null && (
                                    <th colSpan="2">10 Year</th>
                                  )}
                                  {dataHis[0] &&
                                    dataHis[0].CAGRInception != null && (
                                      <th colSpan="2">Since Inception</th>
                                    )}
                                </tr>
                                <tr>
                                  <th>Scheme Name</th>
                                  <th>Date of Inception</th>
                                  {dataHis[0] && dataHis[0].SAR7D != null && (
                                    <>
                                      <th>
                                        SAR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                  {dataHis[0] && dataHis[0].SAR15D != null && (
                                    <>
                                      <th>
                                        SAR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                  {dataHis[0] && dataHis[0].SAR30D != null && (
                                    <>
                                      <th>
                                        SAR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                   {dataHis[0] && dataHis[0].SAR3Mon != null && (
                                    <>
                                      <th>
                                        SAR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                  {dataHis[0] && dataHis[0].SAR6Mon != null && (
                                    <>
                                      <th>
                                        SAR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                  {dataHis[0] && dataHis[0].CAGR1Yr != null && (
                                    <>
                                      <th>
                                        CAGR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                  {dataHis[0] && dataHis[0].CAGR3Yr != null && (
                                    <>
                                      <th>
                                        CAGR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                  {dataHis[0] && dataHis[0].CAGR5Yr != null && (
                                    <>
                                      <th>
                                        CAGR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                   {dataHis[0] && dataHis[0].CAGR10Yr != null && (
                                    <>
                                      <th>
                                        CAGR <br /> Return (%)
                                      </th>
                                      <th>
                                        Current Value of Investment of ₹10,000/-
                                      </th>
                                    </>
                                  )}
                                  {dataHis[0] &&
                                    dataHis[0].CAGRInception != null && (
                                      <>
                                        <th>
                                          CAGR <br /> Return (%)
                                        </th>
                                        <th>
                                          Current Value of Investment of
                                          ₹10,000/-
                                        </th>
                                      </>
                                    )}
                                </tr>
                              </thead> */}

                               <thead>
            <tr>
            <th colSpan="2">
              <span className="sr-only">Scheme Details</span>
            </th>
            {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625")  && <th colSpan="2">7 Days</th>}
            {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && <th colSpan="2">15 Days</th>}
            {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && <th colSpan="2">1 Month</th>}
            {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && <th colSpan="2">3 Months</th>}
            {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && <th colSpan="2">6 Months</th>}
            <th colSpan="2">1 Year</th>
            <th colSpan="2">3 Year</th>
            <th colSpan="2">5 Year</th>
            <th colSpan="2">10 Year</th>
            <th colSpan="2">Since Inception</th>
            </tr>

         <tr>
  <th>Scheme Name</th>
  <th>Date of Inception</th>

  {/* 7 Days */}
  {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
    <>
      <th>
        SAR <br /> Return (%)
      </th>
      <th>Current Value of ₹10,000/-</th>
    </>
  )}

  {/* 15 Days */}
  {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
    <>
      <th>
        SAR <br /> Return (%)
      </th>
      <th>Current Value of ₹10,000/-</th>
    </>
  )}

  {/* 30 Days */}
  {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
    <>
      <th>
        SAR <br /> Return (%)
      </th>
      <th>Current Value of ₹10,000/-</th>
    </>
  )}

  {/* 3 Months */}
  {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
    <>
      <th>
        SAR <br /> Return (%)
      </th>
      <th>Current Value of ₹10,000/-</th>
    </>
  )}

  {/* 6 Months */}
  {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
    <>
      <th>
        SAR <br /> Return (%)
      </th>
      <th>Current Value of ₹10,000/-</th>
    </>
  )}

  {/* 1 Year */}
  <th>
    CAGR <br /> Return (%)
  </th>
  <th>Current Value of ₹10,000/-</th>

  {/* 3 Year */}
  <th>
    CAGR <br /> Return (%)
  </th>
  <th>Current Value of ₹10,000/-</th>

  {/* 5 Year */}
  <th>
    CAGR <br /> Return (%)
  </th>
  <th>Current Value of ₹10,000/-</th>

  {/* 10 Year */}
  <th>
    CAGR <br /> Return (%)
  </th>
  <th>Current Value of ₹10,000/-</th>

  {/* Since Inception */}
  <th>
    CAGR <br /> Return (%)
  </th>
  <th>Current Value of ₹10,000/-</th>
</tr>

          </thead>
 

                               {/* <tbody>
                                {dataHis.map((item, index) => (
                                  <tr key={index}>
                                    <td>
                                      {item.Title != null ? item.Title : "-"}
                                    </td>
                                    <td>
                                      {index === 0
                                        ? item.InceptionDate != null
                                          ? format(
                                              parseISO(item.InceptionDate),
                                              "dd-MMM-yyyy"
                                            )
                                          : "-"
                                        : null}
                                    </td>
                                    
                                    {dataHis[0] && dataHis[0].SAR7D != null && (
                                      <>
                                        <td>
                                          {item.SAR7D != null
                                            ? item.SAR7D
                                            : "-"}
                                        </td>
                                        <td>
                                          {item.VOI7D != null
                                            ? item.VOI7D.toLocaleString()
                                            : "-"}
                                        </td>
                                      </>
                                    )}
                                    {dataHis[0] &&
                                      dataHis[0].SAR15D != null && (
                                        <>
                                          <td>
                                            {item.SAR15D != null
                                              ? item.SAR15D
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI15D != null
                                              ? item.VOI15D.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                    {dataHis[0] &&
                                      dataHis[0].SAR30D != null && (
                                        <>
                                          <td>
                                            {item.SAR30D != null
                                              ? item.SAR30D
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI30D != null
                                              ? item.VOI30D.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                      {dataHis[0] &&
                                      dataHis[0].SAR3Mon != null && (
                                        <>
                                          <td>
                                            {item.SAR3Mon != null
                                              ? item.SAR3Mon
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI3Mon != null
                                              ? item.VOI3Mon.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                      {dataHis[0] &&
                                      dataHis[0].SAR6Mon != null && (
                                        <>
                                          <td>
                                            {item.SAR6Mon != null
                                              ? item.SAR6Mon
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI6Mon != null
                                              ? item.VOI6Mon.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                    {dataHis[0] &&
                                      dataHis[0].CAGR1Yr != null && (
                                        <>
                                          <td>
                                            {item.CAGR1Yr != null
                                              ? item.CAGR1Yr
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI1Yr != null
                                              ? item.VOI1Yr.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                    {dataHis[0] &&
                                      dataHis[0].CAGR3Yr != null && (
                                        <>
                                          <td>
                                            {item.CAGR3Yr != null
                                              ? item.CAGR3Yr
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI3Yr != null
                                              ? item.VOI3Yr.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                    {dataHis[0] &&
                                      dataHis[0].CAGR5Yr != null && (
                                        <>
                                          <td>
                                            {item.CAGR5Yr != null
                                              ? item.CAGR5Yr
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI5Yr != null
                                              ? item.VOI5Yr.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                      {dataHis[0] &&
                                      dataHis[0].CAGR10Yr != null && (
                                        <>
                                          <td>
                                            {item.CAGR10Yr != null
                                              ? item.CAGR10Yr
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOI10Yr != null
                                              ? item.VOI10Yr.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                    {dataHis[0] &&
                                      dataHis[0].CAGRInception != null && (
                                        <>
                                          <td>
                                            {item.CAGRInception != null
                                              ? item.CAGRInception
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.VOIInception != null
                                              ? item.VOIInception.toLocaleString()
                                              : "-"}
                                          </td>
                                        </>
                                      )}
                                  </tr>
                                ))}
                              </tbody>  */}
<tbody>
  {dataHis.map((item, index) => (
    <tr key={index}>
      {/* Scheme Name */}
      <td>{item.Title ?? "NA"}</td>

      {/* Inception Date (only for first row) */}
      <td>
        {index === 0
          ? item.InceptionDate
            ? format(parseISO(item.InceptionDate), "dd-MMM-yyyy")
            : "NA"
          : ""}
      </td>

      {/* 7 Days */}
      {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
        <>
          <td>{item.SAR7D ?? "NA"}</td>
          <td>{item.VOI7D != null ? item.VOI7D.toLocaleString() : "NA"}</td>
        </>
      )}

      {/* 15 Days */}
      {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
        <>
          <td>{item.SAR15D ?? "NA"}</td>
          <td>{item.VOI15D != null ? item.VOI15D.toLocaleString() : "NA"}</td>
        </>
      )}

      {/* 30 Days */}
      {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
        <>
          <td>{item.SAR30D ?? "NA"}</td>
          <td>{item.VOI30D != null ? item.VOI30D.toLocaleString() : "NA"}</td>
        </>
      )}

      {/* 3 Months */}
      {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
        <>
          <td>{item.SAR3Mon ?? "NA"}</td>
          <td>{item.VOI3Mon != null ? item.VOI3Mon.toLocaleString() : "NA"}</td>
        </>
      )}

      {/* 6 Months */}
      {(getSchemeCode === "J13" || getSchemeCode === "J624" || getSchemeCode === "J452" || getSchemeCode === "J625") && (
        <>
          <td>{item.SAR6Mon ?? "NA"}</td>
          <td>{item.VOI6Mon != null ? item.VOI6Mon.toLocaleString() : "NA"}</td>
        </>
      )}

      {/* 1 Year */}
      <td>{item.CAGR1Yr ?? "NA"}</td>
      <td>{item.VOI1Yr != null ? item.VOI1Yr.toLocaleString() : "NA"}</td>
      {/* 3 Year */}
      <td>{item.CAGR3Yr ?? "NA"}</td>
      <td>{item.VOI3Yr != null ? item.VOI3Yr.toLocaleString() : "NA"}</td>

      {/* 5 Year */}
      <td>{item.CAGR5Yr ?? "NA"}</td>
      <td>{item.VOI5Yr != null ? item.VOI5Yr.toLocaleString() : "NA"}</td>

      {/* 10 Year */}
      <td>{item.CAGR10Yr ?? "NA"}</td>
      <td>{item.VOI10Yr != null ? item.VOI10Yr.toLocaleString() : "NA"}</td>

      {/* Since Inception */}
      <td>{item.CAGRInception ?? "NA"}</td>
      <td>
        {item.VOIInception != null
          ? item.VOIInception.toLocaleString()
          : "NA"}
      </td>
    </tr>
  ))}
</tbody>


                            </table>
                          ) : (
                            <p
                              className="text-xsm"
                              style={{ fontWeight: "bold" }}
                            >
                              This Scheme is a new scheme and hence does not
                              have any performance track record.
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  )}
            
              </div>
               {/* <button
                  style={{
                    backgroundColor: "#3EC1CF",   // button color
                    color: "white",               // text color
                    border: "none",
                    borderRadius: "6px",          // rounded corners
                    padding: "6px 3px",
                    fontWeight: "bold",
                    fontSize: "14px",
                    cursor: "pointer",
                    boxShadow: "0 3px 0 #002f87", // bottom shadow (dark blue)
                    marginTop :'1rem'
                  }}
                  className="sip-custom-btn"
                >
                  <a
                    href={SIPPerformancePdf}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "white",
                      textDecoration: "none", // remove underline
                    }}
                  >
                    SIP Performance Details
                  </a>
                </button> */}
                {dataHis && dataHis.some(item => 
                ["CAGR1Yr", "CAGR3Yr", "CAGR5Yr", "CAGR10Yr", "CAGRInception"].some(
                  key => 
                    item[key] === null ||
                    item[key] === undefined ||
                    item[key] === "NA" ||
                    (typeof item[key] === "string" && item[key].toUpperCase() === "NA")
                )
              ) && (
                <p style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                  NA - Not Applicable, since the scheme has not completed requisite number of years from the date of inception.
                </p>
              )}
                {/* <p style={{fontWeight: "bold", fontSize: "0.8rem"}}> NA- Not Applicable, since the scheme has not completed requisite number of years from the date of inception.</p> */}
              <div className="allotment-container">
                {dataHis && (
                  <p className="text-13 mt-2">
                    Past performance may or may not be sustained in future and
                    the same may not necessarily provide the basis for
                    comparison with other investment. Period for which fund’s
                    performance has been provided is computed based on last day
                    of the last month. Different plans shall have different
                    expense structure. The performance details provided here are
                    of{" "}
                    {getSchemeType === "Regular"
                      ? "regular plan"
                      : "direct plan"}
                    . Since inception returns have been calculated from the date
                    of allotment till{" "}
                    {dataHis && dataHis[0]?.AsonDate
                      ? formatDate(dataHis[0].AsonDate)
                      : "-"}
                    . Absolute returns are computed on investments of ₹10,000.
                    Returns are computed on Compounded Annual Growth Rate (CAGR)
                    basis. Source: MFI 360. Returns greater
                    than 1 year period are compounded annualized (CAGR).
                  </p>
                )}
               
                {/* <button className="sip-custom-btn">
                  <a href={SIPPerformancePdf} target="_blank" rel="noreferrer">
                    SIP Performance Details
                  </a>
                </button> */}
                
                <div>
                  <p style={{fontSize: "0.9rem", padding: "10px 0", fontWeight: "bold"}}> ^Scheme Benchmark  &nbsp; *Additional Scheme Benchmark </p>
                </div>
                <button className="product_link" onClick={handleShow} role="link">
                  Scheme Disclaimers
                </button>
                <Modal show={show} className="modal productModal">
                  <Modal.Body>
                    <div className="btnDiv">
                      <div onClick={handleClose}>
                        <AiFillCloseCircle className="btncl" />
                      </div>
                    </div>
                    <div className="bodyModalProduct">
                      <div className="fundManPop">
                        <ul className="sch-disc">
                          <li>
                            For lumpsum investments, if the investment period is
                            less than 1 year then return values are absolute.
                            For periods above 1 year, they are annualized. 1
                            Year is assumed as 365 days.
                          </li>
                          <li>
                            Returns for investments in income distribution cum
                            capital withdrawal (IDCW) plans of schemes are
                            calculated after assuming that the net income
                            distribution cum capital withdrawal (IDCW) payouts
                            post statutory taxes & levies, are re-invested back
                            in the scheme.
                          </li>
                          <li>
                            Income distribution cum capital withdrawals (IDCW)
                            declared from benchmark's constituents isn't taken
                            into account when comparing with investment in
                            fund's income distribution cum capital withdrawal
                            (IDCW) plans.
                          </li>
                          <li>
                            Performance is always compared against the latest
                            benchmark of the fund irrespective of the date of
                            change of fund's benchmark, if any.
                          </li>
                          <li>
                            Past performance may or may not sustain in future
                            and should not be used as a basis for comparison
                            with other investments. There is no assurance of any
                            returns/capital protection/capital guarantee to the
                            investors in any scheme of JM Financial Mutual Fund.
                          </li>
                          <li>
                            The sector(s)/stock(s)/issuer(s) mentioned in this
                            document do not constitute any recommendation of the
                            same and the Fund may or may not have any future
                            position in these sector(s)/stock(s)/issuer(s).
                          </li>
                          <li>
                            The investment approach / framework/ strategy /
                            portfolio / other data mentioned herein are dated
                            and currently followed by the scheme and the same
                            may change in future depending on market conditions
                            and other factors.
                          </li>
                          <li>Source: MFI 360.</li>
                          <li>
                            Past performance may or may not be sustained in
                            future and the same may not necessarily provide the
                            basis for comparison with other investment.
                          </li>
                          <li>
                            Absolute returns are computed on investments of
                            Rs.10,000 for 1 year period. Returns are computed on
                            Compounded Annual Growth Rate (CAGR) basis for
                            periods greater than 1 year. Period for which
                            scheme's performance has been provided is computed
                            on the basis of the last business day of the month.
                          </li>
                          <li>
                            Different plan shall have a different expense
                            structure. Load is not considered for computation of
                            returns. In case the TRI values are not available
                            for a particular period, a composite CAGR gure of
                            the performance of the PRI benchmark (till the date
                            from which TRI is available) and the TRI
                            (subsequently) is used to compare the performance of
                            the scheme. Returns are Compounded Annualised Growth
                            Rate Returns, with reinvestment of IDCW, if any,
                            unless otherwise mentioned. In cases where there has
                            been a change in the benchmark indices of the
                            existing Schemes, the current benchmark has been
                            used for calculating the returns since inception.
                            Returns of benchmark indices since inception date of
                            the Schemes are not available in some cases as the
                            benchmark indices were launched / changed subsequent
                            to the inception date of the Scheme(s). For the
                            purpose of calculating returns, inception date is
                            deemed to be the date of allotment of the units. In
                            plans/options/sub-options, where there were no units
                            on the date of inception, the rst NAV has been
                            considered when units were allotted consequently.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </Tab>
            {
              <Tab eventKey="rollingReturns" title="Rolling Returns">
                <div className="gradiant-head-flex rolling-returns">
                  <div className="gradiant-head-box">
                    <div className="gradiant-head-container paraRolling">
                      {/* <h3 className="gradiant-head left">Rolling Returns</h3> */}
                      {dataHis && (
                        <p className="text-xsm">
                          As on -{" "}
                          {data === null
                            ? "-"
                            : data[0] != null
                            ? format(parseISO(data[0].AsOnDate), "do MMM, yyyy")
                            : "-"}
                        </p>
                      )}
                    </div>
                    <div className="gradiant-content">
                      {loadingshow ? (
                        <div className="textcentervertex">
                          <img src={animation} alt="Loading" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        className="head-container"
                        style={{
                          position: "relative",
                        }}
                      >
                        {dataHis && (

                          <p className="text-13 textRoll">
                            Bars show distribution of returns in given range for
                            selected time period.
                          </p>
                        )}
                        <div className="form-group">
                          {dataHis && (
                            <div className="select-container">
                              <select
                                name="fund"
                                id="fund"
                                autoComplete="off"
                                className="data-selector"
                                onChange={(event) =>
                                  setValue(event.target.value)
                                }
                              >
                                <option value="1year">1 Year</option>
                                <option value="3year">3 Years</option>
                                <option value="5year">5 Years</option>
                              </select>
                              <i
                                className="fa fa-caret-down"
                                aria-hidden="true"
                              ></i>
                            </div>
                          )}
                        </div>
                      </div>
                      {data === null ? (
                        <h6
                          style={{
                            position: "absolute",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                        >
                          This Scheme is a new scheme and hence does not have
                          any performance track record.
                        </h6>
                      ) : (
                        ""
                      )}
                      <div className="img-container HistoricalRoll text-center">
                        {dataHis && (
                          <span className="rolling-Y-text">
                            {" "}
                            % of Instances
                          </span>
                        )}
                        <div
                          id="chartdivHis"
                          style={{
                            width: "100%",
                            height: "280px",
                            marginTop: "-50px",
                          }}
                        ></div>
                        {dataHis && (
                          <span className="rolling-X-text">
                            Range of Returns{" "}
                          </span>
                        )}
                      </div>

                      <div className="allotment-container">
                        {dataHis && value === "1year" ? (
                          <>
                          {/* {console.log(dataHis, "dataHis")} */}
                          <p className="text-13 mt-2">
                            {/* 1 year rolling returns were calculated in CAGR terms
                            on a daily basis for {dataHis[0]?.Title.split("-")[0]} over the
                            period of 3 years from {dateRangeText}.
                            Returns pertain to growth option. Source: Ace MF,
                            JMF MF Research. Past performance may or may not be
                            repeated in the future and the same may not
                            necessarily provide the basis for comparison with
                            other investments. */}
                            For the above table 1 year rolling returns have been considered on a daily basis for 3 years ending {
  (() => {
    const date = dataHis?.[0]?.AsonDate;
    if (!date) return "";

    try {
      return format(parseISO(date), "MMMM dd, yyyy");
    } catch {
      return "";
    }
  })()
}
                          </p>
                          </>
                          
                        ) : dataHis && value === "3year" ? (
                          <p className="text-13 mt-2">
                            For the above table 3 year rolling returns have been considered on a daily basis for 3 years ending {
  (() => {
    const date = dataHis?.[0]?.AsonDate;
    if (!date) return "";

    try {
      return format(parseISO(date), "MMMM dd, yyyy");
    } catch {
      return "";
    }
  })()
}
                          </p>
                        ) : dataHis && value === "5year" ? (
                          <p className="text-13 mt-2">
                            For the above table 5 year rolling returns have been considered on a daily basis for 5 years ending {
  (() => {
    const date = dataHis?.[0]?.AsonDate;
    if (!date) return "";

    try {
      return format(parseISO(date), "MMMM dd, yyyy");
    } catch {
      return "";
    }
  })()
}
                          </p>
                        ) : (
                          ""
                        )}

                        <button className="product_link" onClick={handleShow} role="link">
                          Scheme Disclaimers
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
            }
          </Tabs>
        }
      </section>
    </>
  );
}

export default HistoricalReturn;
